<div class="form-dialog event-type-form-dialog">
  <h1 cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane"><span
  [textContent]="event_type && event_type.id ? 'Edit event type: ' + event_type.attributes.name :  'Add event type'"></span>
</h1>
<mat-dialog-content>
  <mat-tab-group #event_type_tabs (selectedTabChange)="onTabChanged($event)" [disableRipple]="true">
    <mat-tab label="Basic">
      @if (event_type) {
        <form class="form-section column space-between basic">
          <div class="row medium-height">
            <mat-form-field class="inline" style="flex-basis:50%;flex-grow:0;">
              <label>Type</label>
              <mat-select [(ngModel)]="event_type.attributes.base_type" [compareWith]="matSelectCompare"
                name="base_type">
                @for (base of eventService.base_types; track base) {
                  <mat-option [value]="base">{{base}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row medium-height">
            <mat-form-field class="inline" style="flex-basis:50%;flex-grow:0;">
              <label>Name</label>
              <input [(ngModel)]="event_type.attributes.name" matInput name="name" placeholder="">
            </mat-form-field>
          </div>
          <div class="row medium-height">
            <mat-form-field class="inline" style="flex-basis:50%;flex-grow:0;">
              <label>Severity</label>
              <input [(ngModel)]="event_type.attributes.severity" matInput name="severity" placeholder=""
                type=number>
            </mat-form-field>
          </div>
          <div class="row medium-height">
            <mat-form-field class="inline" style="flex-basis:50%;flex-grow:0;">
              <label>Behaviour</label>
              <input [(ngModel)]="event_type.attributes.behaviour" matInput name="behaviour" placeholder="">
            </mat-form-field>
          </div>
          <div class="row center">
            <select-many-search-component
              (itemsRemoved)="removed_component_types=$event;"
              (itemsAdded)="added_component_types=$event;"
              [custom_selected_filters]="selected_component_types_filter"
              [custom_filters]="selected_component_types_reverse_filter"
              [value]="select_component_types"
              [classes]="'fill'"
              [api_model]="'component_type'"
              [label]="'Component Types'"
              class="flex-half alone">
            </select-many-search-component>
            @if (event_type.id) {
              <button (click)="goToTab(event_type_tabs, 3)" mat-raised-button color="primary"
                class="form-element-align">
                Select and edit Component Types relationship
                <i class="fa fa-caret-right" style="margin-left:10px;height: 21px;font-size: 18px;"></i>
              </button>
            }
          </div>
        </form>
      }
    </mat-tab>

    @if (event_type?.id) {
      <mat-tab label="Series">
        <form class="form-section column space-between series">
          <div class="select-search-many" style="flex-grow:2">
            @if (series_list && series_list.length>0) {
              <select-many-search (selectChange)="event_type.relationships.series_list.data=$event"
                [(value)]="event_type.relationships.series_list.data"
                [classes]="'fill'"
                [data]="series_list"
                [fill_stubs]="true"
                [label]="'Series'">
              </select-many-search>
            }
          </div>
          @if (event_type?.relationships.series_list.data && event_type.relationships.series_list.data.length > 0) {
            <table
              class="table event-type-series-table">
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                @for (series of event_type.relationships.series_list.data; track series) {
                  <tr>
                    <td class="edit"><i (click)="editSeries(series)" class="edit-inline hide-xs"></i></td>
                    <td>{{series_dict[series.id]?.attributes.name}}</td>
                    <td>{{series_dict[series.id]?.attributes.description}}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </form>
      </mat-tab>
    }

    @if (event_type?.id) {
      <mat-tab label="Constant Properties" style="width:210px;">
        <ng-template matTabContent>
          <form class="form-section column space-between">
            <div style="height:470px;max-height:470px;">
              <constant-property-table-form
                [parent_component]="event_type"
                [columnWidthDict]="event_type.attributes.json?.property_table_formats || null"
                (columnWidthsChanged)="onPropertyColumnWidthsChanged($event)"
              ></constant-property-table-form>
            </div>
          </form>
        </ng-template>
      </mat-tab>
    }

    @if (event_type?.id) {
      <mat-tab label="Component Types">
        <ng-template matTabContent>
          @if (event_type) {
            <form class="form-section column space-between component-type">
              <div class="row">
                <div class="select-search" style="flex-grow:2">
                  <select-many-search-component
                    (itemsRemoved)="removed_component_types=$event;"
                    (itemsAdded)="added_component_types=$event;"
                    [custom_selected_filters]="selected_component_types_filter"
                    [custom_filters]="selected_component_types_reverse_filter"
                    [value]="select_component_types"
                    [classes]="'fill'"
                    [api_model]="'component_type'"
                    [label]="'Component Types'">
                  </select-many-search-component>
                </div>
              </div>
              @if (selected_component_types?.length > 0) {
                <table
                  class="table event-type-series-table" st-table="rowCollection">
                  <thead>
                    <tr>
                      <th>Edit</th>
                      <th>Name</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (component_type of selected_component_types; track component_type) {
                      <tr>
                        <td class="edit"><i (click)="editComponentType(component_type)" class="edit-inline hide-xs"></i></td>
                        <td>{{component_type.attributes.name}}</td>
                        <td>{{component_type.attributes.description}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
              <a (click)="onCloseClick()" [routerLink]="saving ? null : '/view/component_types/'"
                style="color:darkorange;margin-top:20px;">Go to Component Types table
              </a>
            </form>
          }
        </ng-template>
      </mat-tab>
    }

  </mat-tab-group>
</mat-dialog-content>
<div class="action-buttons">
  <button (click)="onCloseClick()" [disabled]="saving" class="btn-close">Close</button>
  <button (click)="save()" [disabled]="saving" class="btn-save">Save</button>
  <button (click)="apply()" [disabled]="saving" class="btn-save">Apply</button>
</div>
</div>
